let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("elAZn")).then(() => parcelRequire('dBWkl'));